import { render, staticRenderFns } from "./HistoricoVouchers.vue?vue&type=template&id=18384f9b&scoped=true"
import script from "./HistoricoVouchers.vue?vue&type=script&lang=js"
export * from "./HistoricoVouchers.vue?vue&type=script&lang=js"
import style0 from "./HistoricoVouchers.vue?vue&type=style&index=0&id=18384f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18384f9b",
  null
  
)

export default component.exports